const PROGRAM_KEY = {
  APS_RBP: 'APS_RBP',
  PSEG_LI: 'PSEG_LI',
  SWELL: 'SWELL',
  CT_ESS: 'CT_ESS_Eversource',
  GMP_ENPH: 'GMP_ENPH'
}

const FAMILY_KEY = {
  CT_ESS: 'CT_ESS'
}

const PROGRAM_WORKFLOW = {
  API_FLOW: 'GS_API_FLOW'
}

export {
  PROGRAM_KEY,
  FAMILY_KEY,
  PROGRAM_WORKFLOW
}